import React from 'react';
import { HeaderContainer, StopButton, StopButtonWrapper, TrajectoryTitle } from '../atoms/styles';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { useUser } from 'src/modules/shared';
import { StyledUploadFile } from './StyledUploadFile';
import TrajectoryViewDetailInfo from 'src/modules/trajectory/components/TrajectoryViewDetail/TrajectoryViewDetailInfo';
import { ITrajectoryDetail, TrajectorySectionCode } from 'src/config/api/models/Trajectory';

type StudyCardHeaderProps = {
  trainingStarted?: boolean;
  onStopTraining: () => void;
  title?: string;
};

const getTitle = (trajectory: ITrajectoryDetail | undefined) => {
  let title = '';

  if (!trajectory) return title;

  if (trajectory.parentTitle) {
    title = trajectory.parentTitle;
  }
  if (trajectory.title) {
    title = trajectory.title;
  }

  return title;
};

export const StudyCardHeader: React.FC<StudyCardHeaderProps> = ({
  trainingStarted,
  onStopTraining,
  title,
}) => {
  const { isAdmin, isSuperAdmin, isAuthor } = useUser();
  const trajectory = useAppSelector((state) => state.trajectories.trajectory);
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  const currentSectionCode = useAppSelector((state) => state.trajectories.currentSectionCode);

  return (
    <HeaderContainer>
      {!trainingStarted && (
        <div>
          <TrajectoryViewDetailInfo
            trajectoryNumber={trajectory?.number ?? ''}
            trajectoryTitle={getTitle(trajectory)}
            sectionCode={(currentSectionCode as TrajectorySectionCode) ?? ''}
          />
          <span>
            <TrajectoryTitle>{title}</TrajectoryTitle>
          </span>
          {(isAdmin || isSuperAdmin || isAuthor) && viewMode === 'edit' && <StyledUploadFile />}
        </div>
      )}
      {trainingStarted && (
        <StopButtonWrapper>
          <StopButton
            variant="text"
            onClick={() => onStopTraining()}
            startIcon={
              <FontAwesomeSpriteIcon
                icon={SpriteIconsSolid.XMARK}
                iconSize="sm"
                color="secondary"
              />
            }
          >
            stop
          </StopButton>
        </StopButtonWrapper>
      )}
    </HeaderContainer>
  );
};
